var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.638,
    height: 18.709,
    viewBox: "0 0 17.638 18.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attached-paper-clip-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3119",
    "data-name": "Raggruppa 3119",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5853",
    "data-name": "Tracciato 5853",
    d: "M30.688,1.607a5.5,5.5,0,0,0-7.773,0L14.837,9.686a.611.611,0,0,0,.864.864l8.078-8.078a4.275,4.275,0,0,1,6.046,6.046L21.746,16.6a3.054,3.054,0,1,1-4.318-4.318L25.506,4.2A1.832,1.832,0,1,1,28.1,6.789h0l-8.078,8.078A.611.611,0,0,1,19.155,14L26.37,6.789a.611.611,0,0,0-.864-.864L18.291,13.14a1.832,1.832,0,1,0,2.591,2.591l8.078-8.078h0a3.054,3.054,0,0,0-4.318-4.318l-8.078,8.078a4.275,4.275,0,0,0,6.046,6.046L30.688,9.38A5.5,5.5,0,0,0,30.688,1.607Z",
    transform: "translate(-14.658 0)",
    fill: "#6f7070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper_clip.f9879bc4dd20926a6155c482e3ea7b82.svg";
export { ForwardRef as ReactComponent };